const model = { t: 'Model', name: 'model', placeholder: 'Wpisz model lub wersję' } // hint: { url: '/model/heavy', deps: ['marka'], cache: 'heavy-model', exact: true }
export default model